import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-solutions-otc-desk',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './otc-desk.component.html',
  styleUrl: './otc-desk.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionsOtcDeskComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-check',
      anchor: "Online AML check",
      text: "The counterparty check itself, run from the dashboard or from Telegram between quote and settlement.",
    },
    {
      link: '/wallet-screening',
      anchor: "Crypto wallet screening",
      text: "What a settlement address has been close to, read across four AML data providers at once.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "For counterparties you deal with again: keep their wallets under watch rather than re-checking each time.",
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
